

import masterVisitPlanGenerate from "./master/visitPlanGenerate";
export default {
  namespaced: true,
  modules: {
    visitPlanGenerate: masterVisitPlanGenerate,
  }
}
